import { defineRenderNode, type RenderNodeDefsSubset } from './renderNodeDefs.js';

export const BOUNDS_NODE_DEFS: RenderNodeDefsSubset<'SplitBounds' | 'BoundsSize' | 'BoundsCenter' | 'PointInBounds' | 'AdjustBounds'> = {
  SplitBounds: defineRenderNode({
    label: 'Split Bounds', cat: 'bounds',
    inputs: [{ name: 'v', type: 'bounds' }],
    outputs: [
      { name: 'min', label: 'Min', type: 'vec2' },
      { name: 'max', label: 'Max', type: 'vec2' },
      { name: 'minX', label: 'Min X', type: 'float' },
      { name: 'minY', label: 'Min Y', type: 'float' },
      { name: 'maxX', label: 'Max X', type: 'float' },
      { name: 'maxY', label: 'Max Y', type: 'float' }
    ],
  }),
  BoundsSize: defineRenderNode({
    label: 'Bounds Size', cat: 'bounds',
    inputs: [{ name: 'bounds', label: 'Bounds', type: 'bounds' }],
    outputs: [{ name: 'size', label: 'Size', type: 'vec2' }, { name: 'w', type: 'float' }, { name: 'h', type: 'float' }],
  }),
  BoundsCenter: defineRenderNode({
    label: 'Bounds Center', cat: 'bounds',
    inputs: [{ name: 'bounds', label: 'Bounds', type: 'bounds' }],
    outputs: [{ name: 'center', label: 'Center', type: 'vec2' }, { name: 'cx', label: 'Center X', type: 'float' }, { name: 'cy', label: 'Center Y', type: 'float' }],
  }),
  PointInBounds: defineRenderNode({
    label: 'Point in Bounds', cat: 'bounds',
    inputs: [{ name: 'point', label: 'Point', type: 'vec2' }, { name: 'bounds', label: 'Bounds', type: 'bounds' }, { name: 'transform', label: 'Transform', type: 'transform' }],
    outputs: [{ name: 'point', label: 'Point', type: 'vec2' }, { name: 'x', type: 'float' }, { name: 'y', type: 'float' }],
  }),
  AdjustBounds: defineRenderNode({
    label: 'Adjust Bounds', cat: 'bounds',
    inputs: [
      { name: 'bounds', label: 'Bounds', type: 'bounds' },
      { name: 'default', label: 'Default', type: 'float', range: { min: -1000, max: 1000, step: 0.1, subtype: 'distance' } },
      { name: 'left', label: 'Left', type: 'float', range: { min: -1000, max: 1000, step: 0.1, subtype: 'distance' }, optional: true },
      { name: 'top', label: 'Top', type: 'float', range: { min: -1000, max: 1000, step: 0.1, subtype: 'distance' }, optional: true },
      { name: 'right', label: 'Right', type: 'float', range: { min: -1000, max: 1000, step: 0.1, subtype: 'distance' }, optional: true },
      { name: 'bottom', label: 'Bottom', type: 'float', range: { min: -1000, max: 1000, step: 0.1, subtype: 'distance' }, optional: true },
    ],
    outputs: [{ name: 'bounds', label: 'Bounds', type: 'bounds' }],
    graphs: ['material']
  })
};

Object.values(BOUNDS_NODE_DEFS).forEach(def => {
  def.graphs = ['material'];
});
